<template>
  <v-container class="media-cover none-fluid link">
    <banner>Media Coverage</banner>
    <div class="scroll-option-container">
      <span
        v-for="section in content"
        :key="section.title"
        @click="scrollTo(section.title)"
        class="scroll-options"
        >{{ section.title }}</span
      >
    </div>
    <i class="mdi mdi-format-vertical-align-top up-arrow" @click="goTop" />
    <br />
    <v-expansion-panels
      multiple
      v-model="panels"
      class="mx-auto media-coverage-content"
    >
      <v-expansion-panel
        v-for="section in content"
        :key="section.title"
        expand
        :id="section.title.replace(/\s/gi, '-').replace(',', '')"
      >
        <v-expansion-panel-header class="expansion-header">{{
          section.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="expansion-content">
          <div
            v-for="message in section.children"
            :key="message.content"
            class="expansion-subsection expansion-subsection-media"
          >
            <p v-html="$sanitize(message.content)"></p>
            <v-row v-if="message.images && message.images.length === 1">
              <v-col cols="3">
                <image-viewer :url="message.images[0]"></image-viewer>
              </v-col>
            </v-row>
            <v-row v-else-if="message.images && message.images.length > 1">
              <v-col
                v-for="image in message.images"
                :key="image"
                cols="12"
                lg="6"
              >
                <image-viewer :url="image"></image-viewer>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";
import ImageViewer from "../global/ImageViewer";
import { getAllMedia } from "../../service/media/mediaCoverage";

export default {
  data() {
    return {
      panels: [],
      content: [],
    };
  },
  components: {
    Banner,
    ImageViewer,
  },
  mounted() {
    getAllMedia()
      .then((content) => {
        this.content = content;
        for (let i = 0; i < content.length; ++i) {
          this.panels.push(i);
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
  methods: {
    scrollTo(target) {
      const options = {
        duration: 300,
        offset: 50,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo(
        `#${target.replace(/\s/gi, "-").replace(",", "")}`,
        options
      );
    },
    goTop() {
      const options = {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo("body", options);
    },
  },
};
</script>

<style lang="scss">
.media-cover {
  .media-image {
    width: 100%;
    cursor: pointer;
  }
}
</style>